import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CoreNavigationService {

  constructor() { }

  public navigationSource: string = '';

  public calenderNavigation: string = ''
}
